import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import styles from '../../styles/cart/CartProduct.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { totalProductValue } from '../../utils/general/cartUtils';
import CartDeliveryNotice from './CartDeliveryNotice';

const CartTotalPrice = (props) => {

    const {cart, goToNextStep, isError} = props;

    const totalPrice = totalProductValue(cart);

    return (
        <Col xs={12} className={`${styles.root} ${styles.totalPrice} mb-3 p-3 `} >
            <p className={styles.title}>Sumar comandă</p>
            <div className={styles.item}>
                Preț produse
                <span className="float-end">{Intl.NumberFormat('fr').format(totalPrice)} lei</span>
            </div>
            <div className={styles.item}>
                Cost livrare
                <span className="float-end">0 lei</span>
            </div>
            <div className={`${styles.divider} ${styles.price} mt-3 py-3`}>
                Total
                <span className="float-end">{Intl.NumberFormat('fr').format(totalPrice)} lei</span>
            </div>
            
            {isError &&
                <Alert variant="danger">
                    {isError}
                </Alert>
            }
            <Button onClick={goToNextStep}>
                <FontAwesomeIcon icon={faChevronRight} height="16" width="16" className="me-2"/>
                Continuă
            </Button>
            <CartDeliveryNotice />
        </Col>
    );
}

export default CartTotalPrice;